import classNames from "classnames";
import { CONVERSATION_MAKER_HOST, WEB_HOST } from "@/core/variables";
import { Popover, PopoverButton, PopoverItem, PopoverMenu } from "@/component/Popover";
import { AppMenuIcon, CircleIcon } from "@/assets/svgs/icons";


const APP_MENU_CLASSNAME = 
    "selection-table-popover-item w-full p-2.5 rounded-[6px]"
    + " text-black-400 hover:text-chat42 hover:bg-chat42-5 data-[focus]:text-chat42 data-[focus]:bg-chat42-5";

const AppMenu: React.FC<{className?: string}> = ({ className: propsClassName }) => {
    return (
        <Popover>
            <PopoverButton>
                <AppMenuIcon className={classNames("size-8 rounded-[6px] cursor-pointer", propsClassName)}/>
            </PopoverButton>
            <PopoverMenu anchor="bottom start"
                        className="!w-[210px] mt-2 -ml-3 px-3 py-3"
            >
                <PopoverItem onClick={() => { window.open(WEB_HOST); }}
                             className={APP_MENU_CLASSNAME}
                >
                    <CircleIcon className="size-2.5" />
                    NLU
                </PopoverItem>
                <PopoverItem onClick={() => { window.open(CONVERSATION_MAKER_HOST); }}
                             className={APP_MENU_CLASSNAME}
                >
                    <CircleIcon className="size-2.5" />
                    CM
                </PopoverItem>
            </PopoverMenu>
        </Popover>
    );
};

export default AppMenu;
